"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const recharts_1 = require("recharts");
const date_fns_1 = require("date-fns");
function AreaChart({ data, formatter, aspect = 2 }) {
    return (react_1.default.createElement(recharts_1.ResponsiveContainer, { aspect: aspect, width: '100%' },
        react_1.default.createElement(recharts_1.AreaChart, { data: data, className: "dark:bg-black-600 bg-white" },
            react_1.default.createElement(recharts_1.Area, { dataKey: "value", stroke: "#509EE3", strokeWidth: 3, fill: "#509EE3", connectNulls: true, dot: { stroke: '#509EE3', strokeWidth: 2, fill: 'white', r: 5 }, isAnimationActive: false }),
            react_1.default.createElement(recharts_1.Tooltip, { formatter: (value) => [
                    formatter ? formatter(value) : new Intl.NumberFormat('de').format(value),
                ], labelFormatter: (value) => date_fns_1.format(date_fns_1.parseISO(value), 'MMM dd, yyyy') }),
            (data === null || data === void 0 ? void 0 : data.length) > 0 && (react_1.default.createElement(recharts_1.XAxis, { dataKey: "date", tickFormatter: (value) => date_fns_1.format(date_fns_1.parseISO(value), 'MMM dd, yyyy'), 
                /* missing type in library
            // @ts-ignore */
                tickMargin: 10 })),
            react_1.default.createElement(recharts_1.YAxis, { axisLine: false, tickLine: false, tickFormatter: (tick) => formatter ? formatter(tick) : new Intl.NumberFormat('de').format(tick) }))));
}
exports.default = AreaChart;
